module.exports = __webpack_public_path__ + "static/media/DSC_0910.daff4d1a.jpg";